import React from 'react'
import { Tag, Tooltip } from 'antd'
import moment from 'moment'
import { ESellerEmployeeStatus } from 'models/sellerEmployees'

interface IEmployeeStatusTagProps {
  status: ESellerEmployeeStatus
  fired_at?: string | null
  invitation_expires_at?: string | null
}

const formatDate = (date?: string | null) =>
  date ? moment(date).format('DD.MM.YYYY') : '—'

export const EmployeeStatusTag: React.FC<IEmployeeStatusTagProps> = ({
  status,
  fired_at,
  invitation_expires_at
}) => {
  if (status === ESellerEmployeeStatus.ACTIVE) {
    return <Tag color='success'>Работает</Tag>
  }
  if (status === ESellerEmployeeStatus.FIRED) {
    return (
      <Tooltip title={`Уволен ${formatDate(fired_at)}`}>
        <Tag>Уволен</Tag>
      </Tooltip>
    )
  }
  if (
    !invitation_expires_at ||
    moment(invitation_expires_at).isBefore(moment())
  ) {
    return (
      <Tooltip title='Сотрудник не перешёл по ссылке за 7 дней. Отправьте приглашение повторно из карточки сотрудника'>
        <Tag color='warning'>Ссылка истекла</Tag>
      </Tooltip>
    )
  }
  return (
    <Tooltip
      title={`Сотрудник ещё не перешёл по ссылке из письма. Ссылка действует до ${moment(
        invitation_expires_at
      ).format('DD.MM.YYYY HH:mm')}`}
    >
      <Tag color='processing'>Приглашён</Tag>
    </Tooltip>
  )
}
